import React from "react";
import styles from "./ButtonGroup.module.css";

function ButtonGroup({
  children,
  align = "right",
  variant = "",
  framed = false,
  className = "",
  ...props
}) {
  const variantClasses = variant
    .split(" ")
    .map((v) => styles[v])
    .filter(Boolean);

  const classList = [
    styles.group,
    styles[align],
    ...variantClasses,
    framed && styles.frame,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classList} {...props}>
      {children}
    </div>
  );
}

export default ButtonGroup;
